
/*
    the display for an individual stop within a trip within the details component
*/

import React from "react";

export default class BusOpsTimePoint extends React.Component {
    render(){
        const {Description, SchedDepTime, SchedLaneGate} = this.props.data;

        // I should just get the time component of the scheduled time
        // it will just be split by a space

        const time = SchedDepTime.split(" ").slice(1,3).join(" ");

        return (
            <div className="data inner-data" style={{
                display: "grid",
                gridTemplateColumns: "5fr 2fr 2fr",
                padding: "4px 8px",
                marginLeft: "4px",
                marginRight: "4px"
            }}>
                <div style={{
                    display: "flex"
                }}>
                    <span>town:&nbsp;</span><b>{Description}</b>
                </div>
                <div>time: <b>{time}</b></div>
                <div>lane: <b>{SchedLaneGate}</b></div>
            </div>
        )
    }
}